import React, { useEffect, useRef } from "react";
import TAPES from "../data/tapes.json";

const PLAYLIST = "https://open.spotify.com/playlist/6qbC4DFTBDnqSs7rGIjITV";

export function Mixtape() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const T = TAPES;
    let cur = -1, ctl = null, want = null, playing = false;
    const big = root.querySelector(".tape.big");
    const nt = root.querySelector(".now-t");
    const na = root.querySelector(".now-a");
    const pb = root.querySelector(".tkey.play");
    const tapes = [...root.querySelectorAll(".rack .tape")];

    function mark() {
      tapes.forEach((t, i) => t.classList.toggle("on", i === cur));
      root.classList.toggle("on", playing);
      pb.textContent = playing ? "\u275A\u275A" : "\u25B6";
    }
    function load(i, go) {
      cur = (i + T.length) % T.length;
      const x = T[cur], src = tapes[cur];
      big.style.setProperty("--c", src.style.getPropertyValue("--c"));
      big.style.setProperty("--k", src.style.getPropertyValue("--k"));
      nt.textContent = x.t;
      na.textContent = x.a;
      big.classList.remove("in"); void big.offsetWidth; big.classList.add("in");
      const uri = "spotify:track:" + x.id;
      if (ctl) { ctl.loadUri(uri); if (go) setTimeout(() => ctl.play(), 350); } else { want = uri; }
      mark();
    }
    const onTape = tapes.map((t, i) => { const h = () => load(i, true); t.addEventListener("click", h); return [t, h]; });
    const prev = root.querySelector(".tprev"), next = root.querySelector(".tnext"), shuf = root.querySelector(".tshuf");
    prev.onclick = () => load(cur < 0 ? 0 : cur - 1, true);
    next.onclick = () => load(cur + 1, true);
    shuf.onclick = () => load(Math.floor(Math.random() * T.length), true);
    pb.onclick = () => { if (cur < 0) return load(0, true); if (ctl) ctl.togglePlay(); };

    window.onSpotifyIframeApiReady = (api) => {
      api.createController(document.getElementById("sp-embed"), { uri: want || "spotify:playlist:6qbC4DFTBDnqSs7rGIjITV", height: 80, width: "100%" }, (c) => {
        ctl = c;
        c.addListener("playback_update", (e) => { playing = !e.data.isPaused; mark(); });
        c.addListener("ready", () => { if (want && cur >= 0) { c.loadUri(want); want = null; } });
      });
    };

    let s = null;
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting) && !s) {
        s = document.createElement("script");
        s.src = "https://open.spotify.com/embed/iframe-api/v1";
        s.async = true;
        document.body.appendChild(s);
        io.disconnect();
      }
    }, { rootMargin: "400px" });
    io.observe(root);

    // pin the section on desktop: page scroll runs through the whole rack, then releases
    const pin = root.querySelector(":scope > .wrap"), rack = root.querySelector(".rack");
    function sizeMix() {
      if (window.innerWidth < 900) { root.style.height = ""; return; }
      root.style.height = ""; const ov = Math.max(0, rack.scrollHeight - rack.clientHeight);
      const cs = getComputedStyle(root); root.style.height = (pin.offsetHeight + ov + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)) + "px"; onMix();
    }
    function onMix() {
      if (window.innerWidth < 900) return; const r = root.getBoundingClientRect(), pr = pin.getBoundingClientRect(), k = r.width / root.offsetWidth || 1, cs = getComputedStyle(root);
      const top = 70 * k, pt = parseFloat(cs.paddingTop) * k, pb = parseFloat(cs.paddingBottom) * k, range = r.height - pr.height - pt - pb;
      const p = range > 0 ? Math.min(1, Math.max(0, (top - r.top - pt) / range)) : 0; rack.scrollTop = p * (rack.scrollHeight - rack.clientHeight);
    }
    window.addEventListener("scroll", onMix, { passive: true });
    window.addEventListener("resize", sizeMix);
    window.addEventListener("load", sizeMix);
    const mixT = setTimeout(sizeMix, 300);

    return () => {
      io.disconnect();
      onTape.forEach(([t, h]) => t.removeEventListener("click", h));
      window.removeEventListener("scroll", onMix);
      window.removeEventListener("resize", sizeMix);
      window.removeEventListener("load", sizeMix);
      clearTimeout(mixT);
      try { delete window.onSpotifyIframeApiReady; } catch (e) {}
    };
  }, []);

  return (
    <section className="mix" id="mixtape" ref={rootRef} data-testid="mixtape">
      <div className="wrap">
        <div className="sh"><span className="mono">(06) Press play — my mixtape</span><span className="mono">81 tapes · pick one, it plays</span></div>
        <div className="mix-grid">
          <div className="tdeck">
            <div className="deck-top"><span className="mono">VDS-81 · stereo cassette deck</span><span className="tled" /></div>
            <div className="tbay">
              <div className="tape big" style={{ "--c": "#D7FF3B", "--k": "#0D0D12" }}>
                <span className="tlab"><span className="tstrip"><b className="now-t">beep boop beep boop</b><i className="now-a">pick a tape →</i><span className="tside">A</span></span><span className="twin"><span className="treel" /><span className="tmid" /><span className="treel" /></span></span>
                <span className="tfoot" />
              </div>
            </div>
            <div className="tkeys">
              <button className="tkey tprev" aria-label="Previous tape" data-testid="mix-prev">◀◀</button>
              <button className="tkey play" aria-label="Play or pause" data-testid="mix-play">▶</button>
              <button className="tkey tnext" aria-label="Next tape" data-testid="mix-next">▶▶</button>
              <button className="tkey tshuf" aria-label="Shuffle" data-testid="mix-shuffle">⤮</button>
            </div>
            <div className="tsp"><div id="sp-embed" /></div>
            <a className="mono sp-all" href={PLAYLIST} target="_blank" rel="noopener" data-testid="mix-playlist-link">Open the whole playlist on Spotify ↗</a>
          </div>
          <div className="rack" role="list">
            {TAPES.map((x, i) => (
              <button key={i} className="tape" data-i={i} style={{ "--c": x.c, "--k": x.k, "--r": x.r }} aria-label={`Play ${x.t} by ${x.a}`} data-testid={`mix-tape-${i}`}>
                <span className="tlab"><span className="tstrip"><b>{x.t}</b><i>{x.a}</i><span className="tside">A</span></span><span className="twin"><span className="treel" /><span className="tmid" /><span className="treel" /></span></span>
                <span className="tfoot" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
